import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { CheckboxProps } from 'ncoded-component-library/build/components/molecules/Checkbox/Checkbox.component';
import TickIcon from 'icons/Tick.icon';

import './TeamInfo.styles.scss';

type TeamInfoProps = CheckboxProps & {
  className?: string;
  teamName: string;
  members: string[];
};

const TeamInfo: FC<TeamInfoProps> = ({
  className,
  teamName,
  members,
  ...rest
}) => {
  const isChecked = rest.checked;

  const classes = classNames(
    'team-info',
    { 'team-info--checked': isChecked },
    className,
  );

  const membersInfo = useMemo(
    () =>
      members.reduce((acc, curr, index) => {
        if (index === 0) return curr;
        return `${acc}, ${curr}`;
      }, ''),
    [members],
  );

  return (
    <label className={classes}>
      <input value={teamName} {...rest} type="checkbox" />

      <p className="team-info__name">{teamName}</p>
      <span className="team-info__members">{membersInfo}</span>

      {isChecked && <TickIcon />}
    </label>
  );
};

export default TeamInfo;
